export const getSportsbookConfig = () => (window.WH || {}).sportsbook || {};
export const getSeoServiceConfig = () => window.seoService.configuration;

export const isEventPage = () => window.location.pathname.indexOf('OB_EV') > -1;
export const isCompetitionPage = () => window.location.pathname.indexOf('OB_TY') > -1;

export const getCompetitionId = () => (window.location.pathname.match(/OB_TY\d+/g) || [])[0];
